/**
 * Formatage PUR d'un horodatage ISO en heure locale compacte (HH:MM:SS), pour la
 * cloche (« Démarré à … », « … → … » d'un job terminé). `null` si l'entrée est
 * absente/illisible. Le rendu suit la locale/fuseau du navigateur — VOLONTAIRE :
 * on veut l'heure murale de l'utilisateur (pour rapprocher un scan de son action).
 */
export function clock(iso: string | null): string | null {
  if (iso === null) return null;
  const ms = Date.parse(iso);
  if (Number.isNaN(ms)) return null;
  return new Date(ms).toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}
